(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["group-duplicate-two"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const blurElements = document.querySelectorAll('[data-scroll-blur]');

    if (blurElements.length === 0) return;

    let ticking = false;

    function updateBlur() {
      const scrolled = window.pageYOffset;

      blurElements.forEach(function(element) {
        // Calculate blur amount based on scroll position
        // Max blur at 500px scroll = 10px blur
        const blurAmount = Math.min((scrolled / 500) * 20, 20);
        element.style.filter = 'blur(' + blurAmount + 'px)';
      });

      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(updateBlur);
        ticking = true;
      }
    }

    window.addEventListener('scroll', requestTick, { passive: true });

    // Initial state
    updateBlur();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["group-duplicate"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const blurElements = document.querySelectorAll('[data-scroll-blur]');

    if (blurElements.length === 0) return;

    let ticking = false;

    function updateBlur() {
      const scrolled = window.pageYOffset;
      const isMobile = window.innerWidth < 768;
      const offset = isMobile ? 250 : 0;
      const range = 500;

      blurElements.forEach(function(element) {
        const blurAmount = Math.min(Math.max(0, ((scrolled - offset) / range) * 20), 20);
        element.style.filter = 'blur(' + blurAmount + 'px)';
      });

      ticking = false;
    }

    function requestTick() {
      if (!ticking) {
        window.requestAnimationFrame(updateBlur);
        ticking = true;
      }
    }

    window.addEventListener('scroll', requestTick, { passive: true });

    // Initial state
    updateBlur();
  });
  } catch(e) { console.error(e); }
})();

})();
